/**
 * Generate a client_message_id for the chat API. Uses crypto.randomUUID
 * when available; otherwise falls back to a timestamp + random suffix
 * which is sufficient for idempotency keys (collision probability
 * negligible for in-session usage).
 */
export function newClientMessageId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  const ts = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 10);
  return `msg-${ts}-${rand}`;
}
